import { APIClient } from "./_api";

export function login(data) {
  return APIClient.post(`/Admin/login`, data);
}

export function register(data) {
  return APIClient.post(`/register`, data);
}
